import React from "react";

import { CopyToClipboard } from "@magnetic/copy-to-clipboard";

import { Constants } from "src/utils/constants";

import { BaseColumnConfig } from "./baseColumnConfig";

export class CopyColumn<T extends object> extends BaseColumnConfig<T> {
  identity(value?: T) {
    return JSON.stringify(value); // simple id generation from JSON object
  }

  compare(a: T, b: T): number {
    const aVal = JSON.stringify(a, null, "\t");
    const bVal = JSON.stringify(b, null, "\t");
    return aVal.localeCompare(bVal);
  }
  render(val: T) {
    if (!val || Object.keys(val).length === 0) {
      return <div>{Constants.EMPTY_VALUE}</div>;
    }
    return <CopyToClipboard.IconOnly value={JSON.stringify(val, null, "\t")} />;
  }
}
